import React, { useState, memo, useImperativeHandle, forwardRef } from 'react';
import { Input } from 'antd';

const { TextArea } = Input;

const BlankFilling = (props, ref) => {
  const { values = {}, attribute } = props;

  const [inputValue, setInputValue] = useState(values?.text || null);

  useImperativeHandle(ref, () => ({
    getValues: () => ({ text: inputValue }),
  }));

  const onChange = (e) => setInputValue(e.target.value);

  const fieldContent = attribute ? (
    <div className="blank-filling-extra-text">{attribute}:</div>
  ) : null;

  return (
    <div>
      {fieldContent}
      <TextArea
        className="blank-filling-input"
        value={inputValue || ''}
        onChange={onChange}
        placeholder="Please Input"
        autoCapitalize="off"
        autoComplete="off"
        spellCheck="off"
      />
    </div>
  );
};

export default memo(forwardRef(BlankFilling));
